import type { OriginalUserInfo } from '@/utils/umsDataModify.utils';
import type { ConnectFailedReason } from '../../components/ESConnectFailedDialog/ESConnectFailedDialog';

export type TEmailAccountDTO = {
  id: string;
  user_id: string;
  created_date: string;
  last_updated: string;
  email_address: string;
  realtime_sync_activated: boolean;
};

export type TListEmailSyncAccountsDTO = {
  status: string;
  data: {
    total: number;
    emails: TEmailAccountDTO[];
    maximum_account_allowed: number;
  };
};

export type IEmailAccount = {
  id: string;
  userId: string;
  createdDate: string;
  lastUpdated: string;
  emailAddress: string;
  realtimeSyncActivated: boolean;
};

export type IEmailSyncAccount = {
  total: number;
  emails?: IEmailAccount[];
  maximumAccountAllowed: number;
};

export enum ToggleEmailSyncAccountErrorCode {
  INVALID_TOKEN = 'INVALID_TOKEN',
}

export type ToggleEmailSyncAccountResponse = {
  data: TEmailAccountDTO | null;
  errors?: {
    code: ToggleEmailSyncAccountErrorCode | ConnectFailedReason;
  };
  message: string;
  status: number;
  status_code: number;
  ems_first_grant?: boolean;
};

export type AddEmailAccountResponse = {
  access_token: string;
  user_info: OriginalUserInfo;
  ems_first_grant?: boolean;
};
